import React, { PureComponent } from 'react';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import axios from 'axios';
import config from '../../../config';
import withErrorNotification from '../../../hof/withErrorNotification';

class DropZoneField extends PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    customHeight: PropTypes.bool,
    value: PropTypes.string.isRequired,
  };

  static defaultProps = {
    customHeight: false,
  };

  constructor() {
    super();
    this.state = {
      preview: null,
      loading: false
    };
    this.onDrop = this.onDrop.bind(this);
  }

  readFileAsync (file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => {
        resolve(reader.result);
      }
      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    })
  }

  async uploadFileAsync (buffer, filename) {

    let formData = new FormData();
    formData.append('file', new Blob([buffer]), filename ? filename : 'image');

    const options = {
        url: `${config.API_ADDR}/images`,
        method: 'POST',
        data: formData,
        headers: {
          'content-type': 'multipart/form-data'
        }
    }
    const { data: {link} } = await axios(options);
    return link;

  }

  async onDrop(files) {
    await withErrorNotification(async () => {
      try {
        const { onChange } = this.props;

        this.setState({loading: true});

        for(let file of files) {
          const content = await this.readFileAsync(file);
          const link = await this.uploadFileAsync(content);
          console.log(link);
          this.setState({preview: link});
          onChange(link);
        }

        this.setState({loading: false});
      } catch (e) {
        console.error(e);
        throw new Error('File is invalid or too big');
      }
    }, () => {
      this.setState({loading: false});
    });
  }

  componentWillReceiveProps ({value}) {
    if(value) {
      if(!this.state.preview) {
        console.log('received value, ', value);
        this.setState({preview: value});
      }
    }
  }

  removeFile(index, e) {
    const { onChange } = this.props;
    e.preventDefault();
    this.setState({preview: null});
    onChange(null);
  }

  render() {
    const {
      value, customHeight, name,
    } = this.props;

    const files = value;

    console.log('value', value);

    return (
      <div className={`dropzone dropzone--single${customHeight ? ' dropzone--custom-height' : ''}`}>
        <Dropzone
          accept="image/jpeg, image/png"
          name={name}
          multiple={false}
          onDrop={async (fileToUpload) => {
            this.onDrop(fileToUpload);
          }}
        >
          {({ getRootProps, getInputProps }) => (
            <div {...getRootProps()} className={["dropzone__input", this.state.loading ? "dropzone__input-loading" : ''].join(" ")}>
              {(!files || files.length === 0)
              && (
              <div className="dropzone__drop-here">
                <span className="lnr lnr-upload " /> {this.state.loading ? 'Uploading....' : 'Drop file here to upload' }
              </div>
              )}
              <input {...getInputProps()} />
            </div>
          )}
        </Dropzone>
        {files && files.length > 0
        && (
        <aside className="dropzone__img">
          <img src={this.state.preview} alt="drop-img" />
          <button className="dropzone__img-delete" type="button" onClick={e => this.removeFile(0, e)}>
            Remove
          </button>
        </aside>
        )}
      </div>
    );
  }
}

const renderDropZoneField = (props) => {
  const { input, customHeight } = props;
  return (
    <DropZoneField
      {...input}
      customHeight={customHeight}
    />
  );
};

renderDropZoneField.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string,
    onChange: PropTypes.func,
  }).isRequired,
  customHeight: PropTypes.bool,
};

renderDropZoneField.defaultProps = {
  customHeight: false,
};

export default renderDropZoneField;
